import XTbl,{Xtc} from '../../../components/x-table/index';
const tbl = new XTbl('/report/task/', 'task progress');

tbl.add(new Xtc('assign_user', 'User').renderSlot('user').noSort())
tbl.add(new Xtc('pending', 'Pending').noSort().renderSlot('pending'))
tbl.add(new Xtc('progress', 'Progress').noSort().renderSlot('progress'))
tbl.add(new Xtc('review', 'Review').noSort().renderSlot('review'))
tbl.add(new Xtc('complete', 'Completed').noSort().renderSlot('complete'))
tbl.add(new Xtc('total', 'Total Tasks').noSort().renderSlot('total'))

export default tbl;

